/// <reference path="Definitions/custom.d.ts" />
/// <reference path="Definitions/google.maps.d.ts" />

import * as $flag from './_flag'
import * as $modal from './_modal'

var options: any;

export function init($options: any): void {
    options = $.extend(true, {}, $options);

    $flag.bindToggleFlagEvents($("." + options.pageName + " ." + options.pagePrefix + "-flags"));
    
    $("." + options.pageName).find("a").click(function (e) {
        $modal.load($(this).attr("data-link"), {}, false, true, true);
        e.preventDefault();
    });
}